import React from 'react';
import { Trophy } from '@phosphor-icons/react';

interface LearnerRow {
    employeeName: string;
    userId: string;
    completedCount: number;
    completionRate: number;
    totalTimeHours: number;
}

interface OrgTopLearnersWidgetProps {
    data?: LearnerRow[] | null;
    loading?: boolean;
    error?: string;
}

const getInitials = (name: string): string =>
    name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

const RANK_COLORS = [
    'bg-emerald-100 text-emerald-700',
    'bg-blue-100 text-blue-700',
    'bg-purple-100 text-purple-700',
    'bg-amber-100 text-amber-700',
    'bg-emerald-100 text-emerald-700',
];

export const OrgTopLearnersWidget: React.FC<OrgTopLearnersWidgetProps> = ({ data, loading, error }) => {
    const rows = Array.isArray(data) ? data : [];

    return (
        <div className="flex flex-col h-full p-5">
<div className="flex-1">
                {loading ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="w-6 h-6 border-3 border-gray-200 border-t-primary rounded-full animate-spin" />
                    </div>
                ) : error ? (
                    <div className="flex items-center justify-center h-full text-red-500 text-sm">{error}</div>
                ) : rows.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-2">
                        <Trophy className="w-8 h-8" />
                        <span className="text-sm">No learner data</span>
                    </div>
                ) : (
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-[11px] text-gray-400 uppercase tracking-wider border-b border-gray-100">
                                <th className="text-left py-2 font-medium">#</th>
                                <th className="text-left py-2 font-medium">Learner</th>
                                <th className="text-center py-2 font-medium">Completed</th>
                                <th className="text-center py-2 font-medium">Rate</th>
                                <th className="text-right py-2 font-medium">Time</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                            {rows.map((row, idx) => {
                                const avatarClass = RANK_COLORS[idx % RANK_COLORS.length];
                                return (
                                    <tr key={row.userId || idx}>
                                        <td className="py-2.5 text-primary font-bold">{idx + 1}</td>
                                        <td className="py-2.5">
                                            <div className="flex items-center gap-2">
                                                <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold ${avatarClass}`}>
                                                    {getInitials(row.employeeName || '??')}
                                                </div>
                                                <span className="text-gray-800">{row.employeeName}</span>
                                            </div>
                                        </td>
                                        <td className="py-2.5 text-center font-medium text-emerald-600">{Number(row.completedCount) || 0}</td>
                                        <td className="py-2.5 text-center text-xs text-gray-600">{Number(row.completionRate) || 0}%</td>
                                        <td className="py-2.5 text-right text-xs text-gray-500">{Number(row.totalTimeHours) || 0}h</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
